import { render, staticRenderFns } from "./FinishingOptionsPage.vue?vue&type=template&id=28943c4f&scoped=true"
import script from "./FinishingOptionsPage.vue?vue&type=script&lang=js"
export * from "./FinishingOptionsPage.vue?vue&type=script&lang=js"
import style0 from "./FinishingOptionsPage.vue?vue&type=style&index=0&id=28943c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28943c4f",
  null
  
)

export default component.exports